import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const SET_ITEM_INDEX = '[TestTakerAction] SET_ITEM_INDEX';
export const LOAD_TESTLET = '[TestTakerAction] LOAD_TESTLET';
export const PRELOAD_TESTLET = '[TestTakerAction] PRELOAD_TESTLET';
export const LOAD_TESTLET_VERSION = '[TestTakerAction] LOAD_TESTLET_VERSION';
export const LOAD_TESTLET_SUCCESS = '[TestTakerAction] LOAD_TESTLET_SUCCESS';
export const PRELOAD_TESTLET_SUCCESS = '[TestTakerAction] PRELOAD_TESTLET_SUCCESS';
export const LOAD_SNAPSHOT_TESTLET = '[TestTakerAction] LOAD_SNAPSHOT_TESTLET';
export const TEST_NAVIGATION_NEXT = '[TestTakerAction] TEST_NAVIGATION_NEXT';
export const TEST_NAVIGATION_PREVIOUS = '[TestTakerAction] TEST_NAVIGATION_PREVIOUS';
export const LOAD_ASSESSMENT_TEST_BY_TEST_FORM = '[TestTakerAction] LOAD_ASSESSMENT_TEST_BY_TEST_FORM';
export const LOAD_ASSESSMENT_TEST = '[TestTakerAction] LOAD_ASSESSMENT_TEST';
export const LOAD_IPP_ASSESSMENT_TEST = '[TestTakerAction] LOAD_IPP_ASSESSMENT_TEST';
export const LOAD_LATEST_IPP_ASSESSMENT_TEST = '[TestTakerAction] LOAD_LATEST_IPP_ASSESSMENT_TEST';
export const LOAD_ASSESSMENT_TEST_SUCCESS = '[TestTakerAction] LOAD_ASSESSMENT_TEST_SUCCESS';
export const SET_TEST_NAVIGATION = '[TestTakerAction] SET_TEST_NAVIGATION';
export const SET_CAN_GO_NEXT = '[TestTakerAction] SET_CAN_GO_NEXT';
export const INDICATE_END_OF_TEST = '[TestTakerAction] INDICATE_END_OF_TEST';
export const SET_RESPONSE = '[TestTakerAction] SET_RESPONSE';
export const REMOVE_RESPONSE_ITEM = '[TestTakerAction] REMOVE_RESPONSE_ITEM';
export const CLEAR_RESPONSES = '[TestTakerAction] CLEAR_RESPONSES';
export const START_TIMER = '[TestTakerAction] START_TIMER';
export const STOP_TIMER = '[TestTakerAction] STOP_TIMER';
export const PAUSE_TIMER = '[TestTakerAction] PAUSE_TIMER';
export const UNPAUSE_TIMER = '[TestTakerAction] UNPAUSE_TIMER';
export const SET_TEST_TAKER_INFO = '[TestTakerAction] SET_TEST_TAKER_INFO';
export const CACHE_TEST_TAKER_ACTIVITIES = '[TestTakerAction] CACHE_TEST_TAKER_ACTIVITIES';
export const CLEAR_TEST_TAKER_ACTIVITIES = '[TestTakerAction] CLEAR_TEST_TAKER_ACTIVITIES';
export const SET_FLUSH_PAYLOAD = '[TestTakerAction] SET_FLUSH_PAYLOAD';
export const FLUSH_PAYLOAD_SUCCESS = '[TestTakerAction] FLUSH_PAYLOAD_SUCCESS';
export const SHOULD_GO_TO_NEXT_TESTLET = '[TestTakerAction] SHOULD_GO_TO_NEXT_TESTLET';
export const SET_TEST_INITIALIZATION_INFO = '[TestTakerAction] SET_TEST_INITIALIZATION_INFO';
export const LOAD_IPP_PRODUCT = '[TestTakerAction] LOAD_IPP_PRODUCT';
export const SET_IPP_PRODUCT_INFO = '[TestTakerAction] SET_IPP_PRODUCT_INFO';
export const TOGGLE_TIMER_VISIBILITY = '[TestTakerAction] TOGGLE_TIMER_VISIBILITY';
export const GET_STORED_HIGHLIGHTS = '[TestTakerAction] GET_STORED_HIGHLIGHTS';
export const SET_STORED_HIGHLIGHTS = '[TestTakerAction] SET_STORED_HIGHLIGHTS';
export const RESUME_TEST = '[TestTakerAction] RESUME_TEST';

export class SetItemIndex implements Action {
  readonly type = SET_ITEM_INDEX;
  constructor(public payload: number) { }
}

export class LoadTestlet implements Action {
  readonly type = LOAD_TESTLET;
  payload: { testletId: number, assessmentTestId: number };
  constructor(testletId: number, assessmentTest: PgRendererDto.AssessmentTest) {
    this.payload = {
      testletId: testletId,
      assessmentTestId: assessmentTest == null || isNaN(parseInt(assessmentTest.Identifier, 10)) ? 0 : parseInt(assessmentTest.Identifier, 10)
    };
  }
}

export class PreloadTestlet implements Action {
  readonly type = PRELOAD_TESTLET;
  payload: { testletId: number, assessmentTestId: number };
  constructor(testletId: number, assessmentTest: PgRendererDto.AssessmentTest) {
    this.payload = {
      testletId: testletId,
      assessmentTestId: assessmentTest == null || isNaN(parseInt(assessmentTest.Identifier, 10)) ? 0 : parseInt(assessmentTest.Identifier, 10)
    };
  }
}

export class LoadTestletVersion implements Action {
  readonly type = LOAD_TESTLET_VERSION;
  payload: number;
  constructor(testletVersionId: number) {
    this.payload = testletVersionId;
  }
}

export class LoadTestletSuccess implements Action {
  readonly type = LOAD_TESTLET_SUCCESS;
  payload: PgRendererDto.TestletDefinition;
  constructor(testlet: PgRendererDto.TestletDefinition) {
    this.payload = testlet;
  }
}

export class PreloadTestletSuccess implements Action {
  readonly type = PRELOAD_TESTLET_SUCCESS;
  payload: PgRendererDto.TestletDefinition;
  constructor(testlet: PgRendererDto.TestletDefinition) {
    this.payload = testlet;
  }
}

export class LoadSnapshotTestlet implements Action {
  readonly type = LOAD_SNAPSHOT_TESTLET;
  payload: string;
  constructor(snapShotId: string) {
    this.payload = snapShotId;
  }
}

export class TestNavigationNext implements Action {
  readonly type = TEST_NAVIGATION_NEXT;
  payload: { currentTestPartIndex: number, currentTestletIndex: number };
  constructor(currentTestPartIndex: number, currentTestletIndex: number) {
    this.payload = { currentTestPartIndex, currentTestletIndex };
  }
}

export class TestNavigationPrevious implements Action {
  readonly type = TEST_NAVIGATION_PREVIOUS;
  constructor() { }
}

export class LoadAssessmentTestByTestForm implements Action {
  readonly type = LOAD_ASSESSMENT_TEST_BY_TEST_FORM;
  payload: number;
  constructor(testFormId: number) {
    this.payload = testFormId;
  }
}

export class LoadAssessmentTest implements Action {
  readonly type = LOAD_ASSESSMENT_TEST;
  payload: number;
  constructor(assessmentTestId: number) {
    this.payload = assessmentTestId;
  }
}

export class LoadIppAssessmentTest implements Action {
  readonly type = LOAD_IPP_ASSESSMENT_TEST;
  payload: number;
  constructor(assessmentTestId: number) {
    this.payload = assessmentTestId;
  }
}

export class LoadLatestIppAssessmentTest implements Action {
  readonly type = LOAD_LATEST_IPP_ASSESSMENT_TEST;
  payload: string;
  constructor(ippAssessmentTestId: string) {
    this.payload = ippAssessmentTestId;
  }
}

export class LoadAssessmentTestSuccess implements Action {
  readonly type = LOAD_ASSESSMENT_TEST_SUCCESS;
  payload: PgRendererDto.AssessmentTest;
  constructor(assessmentTest: PgRendererDto.AssessmentTest) {
    this.payload = assessmentTest;
  }
}

export class SetTestNavigation implements Action {
  readonly type = SET_TEST_NAVIGATION;
  payload: PgRendererDto.TestNavigation;
  constructor(testNavigation: PgRendererDto.TestNavigation) {
    this.payload = testNavigation;
  }
}

export class SetCanGoNext implements Action {
  readonly type = SET_CAN_GO_NEXT;
  payload: boolean;
  constructor(canGoNext: boolean) {
    this.payload = canGoNext;
  }
}

export class IndicateEndOfTest implements Action {
  readonly type = INDICATE_END_OF_TEST;
  constructor() { }
}

export class SetResponse implements Action {
  readonly type = SET_RESPONSE;
  payload: PgRendererDto.InteractionResponse;
  constructor(response: PgRendererDto.InteractionResponse) {
    this.payload = response;
  }
}

export class RemoveResponseItem implements Action {
  readonly type = REMOVE_RESPONSE_ITEM;
  payload: { interactionId: number, value: string };
  constructor(interactionId: number, value: string) {
    this.payload = { interactionId, value };
  }
}

export class ClearResponses implements Action {
  readonly type = CLEAR_RESPONSES;
  payload: number;
  constructor(interactionId: number) {
    this.payload = interactionId;
  }
}

export class StartTimer implements Action {
  readonly type = START_TIMER;
  payload: { timeLimits: PgRendererDto.TimeLimits, speakingPreparationTime: number, speakingRecordingTime: number, timerVisibility: boolean, timesUpCallback: Function, showTimesUpWarning: boolean, multiplier: number, timeAlreadyUsed: number};
  constructor(timeLimits: PgRendererDto.TimeLimits, speakingPreparationTime: number, speakingRecordingTime: number, timerVisibility: boolean, timesUpCallback: Function, showTimesUpWarning: boolean, multiplier: number, timeAlreadyUsed: number) {
    this.payload = { timeLimits, speakingPreparationTime, speakingRecordingTime, timerVisibility, timesUpCallback, showTimesUpWarning, multiplier,  timeAlreadyUsed};
  }
}

export class StopTimer implements Action {
  readonly type = STOP_TIMER;
  constructor() { }
}

export class PauseTimer implements Action {
  readonly type = PAUSE_TIMER;
  constructor() { }
}

export class UnpauseTimer implements Action {
  readonly type = UNPAUSE_TIMER;
  constructor() { }
}

export class SetTestTakerInfo implements Action {
  readonly type = SET_TEST_TAKER_INFO;
  payload: PgRendererDto.TestTakerStationAssignment;
  constructor(testTakerInfo: PgRendererDto.TestTakerStationAssignment) {
    this.payload = testTakerInfo;
  }
}

export class CacheTestTakerActivities implements Action {
  readonly type = CACHE_TEST_TAKER_ACTIVITIES;
  payload: PgRendererDto.TestTakerActivity[];
  constructor(testTakerActivities: PgRendererDto.TestTakerActivity[]) {
    this.payload = testTakerActivities;
  }
}

export class ClearTestTakerActivities implements Action {
  readonly type = CLEAR_TEST_TAKER_ACTIVITIES;
  constructor() { }
}

export class SetFlushPayload implements Action {
  readonly type = SET_FLUSH_PAYLOAD;
  payload: PgRendererDto.TdpTestTakerResponse;
  constructor(flushPayload: PgRendererDto.TdpTestTakerResponse) {
    this.payload = flushPayload;
  }
}

export class FlushPayloadSuccess implements Action {
  readonly type = FLUSH_PAYLOAD_SUCCESS;
  payload: boolean;
  constructor(shouldGoToNextTestlet: boolean) {
    this.payload = shouldGoToNextTestlet;
  }
}

export class ShouldGoToNextTestlet implements Action {
  readonly type = SHOULD_GO_TO_NEXT_TESTLET;
  payload: boolean;
  constructor(shouldGoToNextTestlet: boolean) {
    this.payload = shouldGoToNextTestlet;
  }
}

export class SetTestInitializationInfo implements Action {
  readonly type = SET_TEST_INITIALIZATION_INFO;
  payload: PgRendererDto.TestInitializationInfo;
  constructor(testInitializationInfo: PgRendererDto.TestInitializationInfo) {
    this.payload = testInitializationInfo;
  }
}

export class LoadIppProduct implements Action {
  readonly type = LOAD_IPP_PRODUCT;
  payload: number;
  constructor(productId: number) {
    this.payload = productId;
  }
}

export class SetIppProductInfo implements Action {
  readonly type = SET_IPP_PRODUCT_INFO;
  payload: PgRendererDto.IppAssessmentTestDto;
  constructor(dto: PgRendererDto.IppAssessmentTestDto) {
    this.payload = dto;
  }
}

export class ToggleTimerVisibility implements Action {
  readonly type = TOGGLE_TIMER_VISIBILITY;
  payload: boolean;
  constructor(visible: boolean) {
    this.payload = visible;
  }
}

export class GetStoredHighlights implements Action {
  readonly type = GET_STORED_HIGHLIGHTS;
  payload: number;
  constructor(resourceId: number) {
    this.payload = resourceId;
  }
}

export class SetStoredHighlights implements Action {
  readonly type = SET_STORED_HIGHLIGHTS;
  payload: PgRendererDto.HighlightDto;
  constructor(highlightDto: PgRendererDto.HighlightDto) {
    this.payload = highlightDto;
  }
}

export class ResumeTest implements Action {
  readonly type = RESUME_TEST;
  constructor() {}
}

export type All
  = SetItemIndex
  | LoadTestlet
  | LoadTestletVersion
  | LoadTestletSuccess
  | LoadSnapshotTestlet
  | TestNavigationNext
  | TestNavigationPrevious
  | LoadAssessmentTestByTestForm
  | LoadAssessmentTest
  | LoadIppAssessmentTest
  | LoadLatestIppAssessmentTest
  | LoadAssessmentTestSuccess
  | SetTestNavigation
  | SetCanGoNext
  | IndicateEndOfTest
  | SetResponse
  | RemoveResponseItem
  | ClearResponses
  | StartTimer
  | StopTimer
  | PauseTimer
  | UnpauseTimer
  | SetTestTakerInfo
  | CacheTestTakerActivities
  | ClearTestTakerActivities
  | SetFlushPayload
  | FlushPayloadSuccess
  | ShouldGoToNextTestlet
  | SetTestInitializationInfo
  | LoadIppProduct
  | SetIppProductInfo
  | ToggleTimerVisibility
  | GetStoredHighlights
  | SetStoredHighlights
  | ResumeTest
  ;



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/actions/test-taker.action.ts